import { Product } from '../models/Product';

export function getProductVariantDescription(
    product: Product,
    variantId: string
): string {
    if (
        product.options.length === 1 &&
        product.options[0].values.length === 1
    ) {
        return `**${product.name}**`;
    }
    const variant = product.variants.find(v => v.variantId === variantId);
    if (!variant) {
        return `**${product.name}**`;
    }
    const optionsText = variant.selectedOptions
        .map(option => `${option.name}: **${option.value}**`)
        .join('\\\n');
    return `**${product.name}**\\\n${optionsText}`;
}
